<template>
    <v-card id="card" flat class="bg-gray">
        <v-card-title id="headerFrame" class="ma-0 pa-0 px-5"><h4>{{personalEval.questionText}}</h4></v-card-title>
        <v-divider id="divider"/>
        <div id="circleFrame">
            <DoughnutChart :data="personalEval.scores"/>
        </div>
        </v-card>
</template>


<script>
import DoughnutChart from './Charts/DoughnutChart.vue';
    export default {
    props: [
        "personalEval"
    ],
    data() {
        return {};
    },
    mounted() {

    },
    methods: {},
    components: { DoughnutChart }
};
</script>
<style scoped>
#card{
    height:400px;
}
#circleFrame{
  height:300px;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
}
#headerFrame{
    height: 100px
}
</style>